import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import Toast from "../../components/Toast";
import Mobilemenu from "../../layouts/mobile-menu";
import { saveUser } from "../../actions/UserActions";

function AddUser() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const loading = useSelector(state => state?.loading?.loading);

    const save = () => {
        if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else if (email.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Email is Required!'
            })
        } else if (password.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Password is Required!'
            })
        }
        else {
            let data = {
                user_name: name,
                email_address: email,
                password: password
            }
            dispatch(saveUser(data, navigate));
        }
        // window.location.href = ('/state');
    }

    const [isEmailValid, setIsEmailValid] = useState(true);

    const handleChangeEmail = (e) => {
        setEmail(e.target.value);

        // Validate the email format
        const isValidEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(e.target.value);
        setIsEmailValid(isValidEmail);
    };

    return (
        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    <div className="intro-y d-flex align-items-center mt-8">
                        <h2 className="fs-lg fw-medium me-auto">
                            Add User
                        </h2>
                    </div>
                    <div className="grid columns-12 gap-6 mt-5">
                        <div className="intro-y g-col-12">
                            {/* <!-- BEGIN: Form Layout --> */}
                            <div className="intro-y box p-5">
                                <div className="grid columns-12">
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="name" className="form-label">Name <span className="text-theme-6">*</span> :</label>
                                        <input id="name" name="name" value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control" placeholder="Enter Name" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="email" className="form-label">Email :</label>
                                        <input id="email" name="email" type="text" value={email} onChange={(e) => handleChangeEmail(e)} className={`form-control ${isEmailValid ? '' : 'is-invalid'}`} placeholder="Enter Email" />
                                        {!isEmailValid && <div className="invalid-feedback">Please enter a valid email address.</div>}

                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="password" className="form-label">Password <span className="text-theme-6">*</span> :</label>
                                        <input id="password" name="password" type="password" value={password} className="form-control" onChange={(e) => setPassword(e.target.value)} placeholder="Enter Password" />
                                    </div>
                                </div>
                                <div className="text-end mt-5">
                                    <button type="button" onClick={() => navigate('/users')} className="btn btn-outline-secondary w-24 me-1">Back</button>
                                    <button onClick={save} type="button" disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button>
                                </div>
                            </div>
                            {/* <!-- END: Form Layout --> */}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddUser;